export const LOGIN_ROUTE = "/login";
export const ORG_AUTHORIZE_ROUTE = "/authorize";
export const LOGOUT_ROUTE = "/logout";
export const SIGNUP_ROUTE = "/signup";
export const SIGNUP_DEALER_GROUP_ROUTE = "/signup/dealergroup/new";
export const SIGNUP_DEFAULT_PLANNER_ROUTE = "/signup/defaultplanner/new";
export const COMPLETE_DEFAULT_SIGNUP_ROUTE = "/setup/i/:authString";
export const COMPLETE_DEALER_GROUP_SIGNUP_ROUTE = "/setup/d/:authString";
